import { gql } from '@/modes/admin/gql';

export const CREATE_COMPANY = gql(`
  mutation CreateCompany($input: CreateCompanyInput!) {
    createCompany(input: $input) {
      id
      name
      phones {
        id
        subType
        value
        extension
      }
      emails {
        id
        subType
        value
      }
      contactAddressId
      contactAddress {
        id
        street1
        street2
        city
        state
        zip
        zipExt
      }
      billingAddressId
      billingAddress {
        id
        street1
        street2
        city
        state
        zip
        zipExt
      }
    }
  }
`);

export const UPDATE_COMPANY = gql(`
  mutation UpdateCompany($id: ID!, $input: UpdateCompanyInput!) {
    updateCompany(id: $id, input: $input) {
      id
      name
      phones {
        id
        subType
        value
        extension
      }
      emails {
        id
        subType
        value
      }
      contactAddressId
      contactAddress {
        id
        street1
        street2
        city
        state
        zip
        zipExt
      }
      billingAddressId
      billingAddress {
        id
        street1
        street2
        city
        state
        zip
        zipExt
      }
    }
  }
`);
